import { StrictMode } from 'react';

import { ProductDetail } from './ProductDetail';
import { Recommendations } from './Recommendations/Recommendations';

const ProductDetailWrapper = (): JSX.Element => (
    <StrictMode>
        <Recommendations />
        <ProductDetail />
    </StrictMode>
);

export { ProductDetailWrapper };
